import { func, shape } from 'prop-types';
import {
  IntlProvider,
  FormattedMessage,
  FormattedDate,
  FormattedTime,
  FormattedDateTimeRange,
  createIntl,
  createIntlCache,
  injectIntl,
  useIntl,
} from 'react-intl';

const intlShape = shape({
  formatDate: func.isRequired,
  formatDateTimeRange: func.isRequired,
  formatMessage: func.isRequired,
  formatNumber: func.isRequired,
  formatPlural: func.isRequired,
  formatRelativeTime: func.isRequired,
  formatTime: func.isRequired,
});
export {
  IntlProvider,
  FormattedMessage,
  FormattedDate,
  FormattedTime,
  FormattedDateTimeRange,
  createIntl,
  createIntlCache,
  injectIntl,
  useIntl,
  intlShape,
};
